import gql from "graphql-tag";

const GET_ORGANIZATION_BY_ID = gql`
  query GetOrganizationById($organizationId: ID!) {
    getOrganizationById(organizationId: $organizationId) {
      organizationName
      organizationTaxId
      organizationOwner
      organizationProfilePicture
      organizationAddress
      socialMediaLinks {
        companyWebsite
        companyLinkedIn
        companyFacebook
      }
    }
  }
`;

export const GET_ORGANIZATIONS_BY_IDS = gql`
  query getOrganizationsByIds($organizationIds: [ID!]) {
    getOrganizationsByIds(organizationIds: $organizationIds) {
      id
      organizationName
    }
  }
`;

export default GET_ORGANIZATION_BY_ID;
